export enum EFioErrorMessages {
  InvalidToken = 'Invalid dadata FIO api token',
  InvalidResponse = 'Invalid dadata FIO response code',
  ErrorRequest = 'Unable to perform dadata FIO request',
}

export enum EAddressErrorMessages {
  InvalidToken = 'Invalid dadata address api token',
  InvalidResponse = 'Invalid dadata address response code',
  ErrorRequest = 'Unable to perform dadata address request',
}
